module.exports = __webpack_public_path__ + "img/wheelchair.5fc1f897.svg";